import styled from '@emotion/styled';
import { Button, SpaceDivider, Text } from '@innovationdepartment/proxima-ui';
import LoadingSpinner from 'ui/LoadingSpinner';

type RemoveTagConfirmationViewProps = {
  confirm: () => void;
  close: () => void;
  tagDisplayName: string;
  isLoading: boolean;
};

const ButtonGroup = styled.div`
  display: inline-flex;
  justify-content: end;
  width: 100%;
  button:first-of-type {
    margin-right: 1rem;
  }
`;

const TextWrapper = styled.div`
  & p {
    font-weight: 400;
  }
`;

const LoadingSpinnerWrapper = styled.div`
  display: block;
  width: 30vw;
  text-align: center;
`;

const RemoveTagConfirmationView = ({
  confirm,
  close,
  tagDisplayName,
  isLoading
}: RemoveTagConfirmationViewProps) => (
  <TextWrapper>
    {isLoading ? (
      <LoadingSpinnerWrapper>
        <LoadingSpinner size={100} />
      </LoadingSpinnerWrapper>
    ) : (
      <>
        <SpaceDivider y={2} />
        <Text variant="body1">
          Are you sure you want to remove the tag <strong>{tagDisplayName}</strong> from this brand?
        </Text>
        <SpaceDivider y={6} />
        <ButtonGroup>
          <Button size="small" variant="outlined" label="Cancel" onClick={close} />
          <Button size="small" color="error" label="Remove" onClick={confirm} />
        </ButtonGroup>
      </>
    )}
  </TextWrapper>
);

export default RemoveTagConfirmationView;
